<template>
  <el-dialog :title="$t('activitiesManage.signup.title')" :visible.sync="dialogVisible" width="80%" @close="handleClose">
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('activitiesManage.signup.listTitle') }}</span>
        <el-button type="primary" size="small" @click="_openAddSignupModal">
          <i class="el-icon-plus"></i>
          {{ $t('common.add') }}
        </el-button>
      </div>
      <el-table :data="signupInfo.signups" border style="width: 100%">
        <el-table-column prop="signupId" :label="$t('activitiesManage.signup.table.signupId')" align="center" />
        <el-table-column prop="memberName" :label="$t('activitiesManage.signup.table.name')" align="center" />
        <el-table-column prop="phone" :label="$t('activitiesManage.signup.table.phone')" align="center" />
        <el-table-column prop="createTime" :label="$t('activitiesManage.signup.table.signupTime')" align="center" />
        <el-table-column :label="$t('activitiesManage.signup.table.statusCd')" align="center">
          <template slot-scope="scope">
            {{ scope.row.statusCd === '1000' ? $t('activitiesManage.signup.status.normal') : $t('activitiesManage.signup.status.cancel') }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" align="center" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="_openEditSignupModal(scope.row)">
              {{ $t('common.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteSignupModal(scope.row)">
              {{ $t('common.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]" :page-size="page.size"
        :total="page.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" style="margin-top:20px;text-align:right" />
    </el-card>

    <!-- 添加/编辑报名人员弹窗 -->
    <el-dialog :title="editForm.signupId ? $t('common.edit') : $t('common.add')" :visible.sync="editDialogVisible" width="60%">
      <el-form ref="editForm" :model="editForm" label-width="120px" :rules="rules">
        <el-form-item :label="$t('activitiesManage.signup.form.name')" prop="memberName">
          <el-input v-model="editForm.memberName" :placeholder="$t('activitiesManage.signup.form.namePlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('activitiesManage.signup.form.phone')" prop="phone">
          <el-input v-model="editForm.phone" :placeholder="$t('activitiesManage.signup.form.phonePlaceholder')" />
        </el-form-item>
        <el-form-item :label="$t('activitiesManage.signup.form.statusCd')" prop="statusCd">
          <el-select v-model="editForm.statusCd" :placeholder="$t('activitiesManage.signup.form.statusCdPlaceholder')" style="width:100%">
            <el-option :label="$t('activitiesManage.signup.status.normal')" value="1000" />
            <el-option :label="$t('activitiesManage.signup.status.cancel')" value="2000" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="primary" @click="handleEditSubmit">{{ $t('common.save') }}</el-button>
      </span>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog :title="$t('common.delete')" :visible.sync="deleteDialogVisible" width="40%">
      <p>{{ $t('activitiesManage.signup.deleteConfirm') }}</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">{{ $t('common.cancel') }}</el-button>
        <el-button type="danger" @click="handleDeleteSubmit">{{ $t('common.delete') }}</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import { listActivitiesSignup, saveActivitiesSignup, updateActivitiesSignup, deleteActivitiesSignup } from '@/api/oa/activitiesManageApi'

export default {
  name: 'ActivitiesSignupView',
  data() {
    return {
      dialogVisible: false,
      editDialogVisible: false,
      deleteDialogVisible: false,
      currentActivity: {},
      signupInfo: {
        signups: [],
        total: 0
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      editForm: {
        signupId: '',
        activitiesId: '',
        memberId: '',
        memberName: '',
        phone: '',
        statusCd: '1000',
        communityId: ''
      },
      deleteForm: {
        signupId: ''
      },
      rules: {
        memberName: [
          { required: true, message: this.$t('activitiesManage.signup.validate.nameRequired'), trigger: 'blur' }
        ],
        phone: [
          { required: true, message: this.$t('activitiesManage.signup.validate.phoneRequired'), trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: this.$t('activitiesManage.signup.validate.phonePattern'), trigger: 'blur' }
        ],
        statusCd: [
          { required: true, message: this.$t('activitiesManage.signup.validate.statusCdRequired'), trigger: 'change' }
        ]
      }
    }
  },
  methods: {
    open(activity) {
      this.currentActivity = activity
      this.dialogVisible = true
      this.$nextTick(() => {
        this.page.current = 1
        this._listSignups()
      })
    },
    async _listSignups() {
      try {
        const params = {
          activitiesId: this.currentActivity.activitiesId,
          page: this.page.current,
          row: this.page.size,
          communityId: getCommunityId()
        }
        console.log('请求参数:', params)
        const { data, total } = await listActivitiesSignup(params)
        console.log('返回数据:', data, total)
        this.signupInfo.signups = data
        this.page.total = total
      } catch (error) {
        console.error('获取报名列表失败:', error)
        this.signupInfo.signups = []
        this.page.total = 0
      }
    },
    _openAddSignupModal() {
      this.editForm = {
        signupId: '',
        activitiesId: this.currentActivity.activitiesId,
        memberId: '',
        memberName: '',
        phone: '',
        statusCd: '1000',
        communityId: getCommunityId()
      }
      this.editDialogVisible = true
    },
    _openEditSignupModal(row) {
      this.editForm = {
        ...row,
        communityId: getCommunityId()
      }
      this.editDialogVisible = true
    },
    _openDeleteSignupModal(row) {
      this.deleteForm.signupId = row.signupId
      this.deleteDialogVisible = true
    },
    async handleEditSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          try {
            if (this.editForm.signupId) {
              await updateActivitiesSignup(this.editForm)
            } else {
              await saveActivitiesSignup(this.editForm)
            }
            this.$message.success(this.$t('common.operationSuccess'))
            this.editDialogVisible = false
            this._listSignups()
          } catch (error) {
            console.error('保存报名信息失败:', error)
          }
        }
      })
    },
    async handleDeleteSubmit() {
      try {
        await deleteActivitiesSignup(this.deleteForm)
        this.$message.success(this.$t('common.operationSuccess'))
        this.deleteDialogVisible = false
        this._listSignups()
      } catch (error) {
        console.error('删除报名信息失败:', error)
      }
    },
    handleSizeChange(val) {
      this.page.size = val
      this._listSignups()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listSignups()
    },
    handleClose() {
      this.$emit('success')
    }
  }
}
</script>

<style lang="scss" scoped>
.box-card {
  margin-bottom: 20px;
}
</style>